import { Checkbox, Space, Typography } from 'antd'
import { useVersionAwareDrilldownPanelData } from 'features/drilldown/data/DrilldownPanelDataContext'
import groupBy from 'lodash/groupBy'
import uniq from 'lodash/uniq'
import { FC, useCallback, useMemo } from 'react'

import { MetricsPanelData } from './MetricsPanel'
import {
  DEFAILT_AVAILABLE_METRIC_CONFIGS,
  DrilldownMetricConfig,
} from './MetricsPanelConfig'

export const MetricsPanelConfigView: FC = () => {
  const {
    panelData: { activeMetrics },
    setPanelData,
  } = useVersionAwareDrilldownPanelData<MetricsPanelData>()

  const handleCheck = useCallback(
    (metricType: string, checked: boolean) => {
      setPanelData((prev) => {
        const newActiveMetrics = checked
          ? uniq([...prev.activeMetrics, metricType])
          : prev.activeMetrics.filter((t) => metricType !== t)
        return {
          ...prev,
          activeMetrics: newActiveMetrics,
        }
      })
    },
    [setPanelData]
  )

  const optionsByRolodexType: Record<string, readonly DrilldownMetricConfig[]> =
    useMemo(() => {
      return groupBy(DEFAILT_AVAILABLE_METRIC_CONFIGS, 'rolodexType')
    }, [])

  return (
    <div style={{ width: '100%' }}>
      <Space orientation='vertical' size='small'>
        {Object.entries(optionsByRolodexType).map(
          ([rolodexType, metricConfigs]) => (
            <Space orientation='vertical' size='small' key={rolodexType}>
              <Typography.Title level={5}>{rolodexType}</Typography.Title>
              {metricConfigs.map((metricConfig) => (
                <Checkbox
                  key={metricConfig.metricType}
                  checked={activeMetrics.includes(metricConfig.metricType)}
                  onChange={(e) =>
                    handleCheck(metricConfig.metricType, e.target.checked)
                  }>
                  {metricConfig.title}
                </Checkbox>
              ))}
            </Space>
          )
        )}
      </Space>
    </div>
  )
}
